import { ORDER_TYPES, SCHEDULE_TYPES } from '@nandosaus/constants';
import { types } from 'mobx-state-tree';

import { formatDateString } from '../../util/time';
import Restaurant from '../../models/restaurant';

const initialState = {};

const OrderConfirmationState = types
  .model('OrderConfirmationState', {
    deliveryTrackingUrl: types.maybe(types.string),
    estimatedDeliveryTime: types.maybe(types.string),
    orderId: types.maybe(types.string),
    orderReference: types.maybe(types.string),
    orderType: types.maybe(types.enumeration([ORDER_TYPES.PICK_UP, ORDER_TYPES.DINE_IN, ORDER_TYPES.DELIVERY])),
    orderPickupType: types.maybe(types.enumeration([SCHEDULE_TYPES.ASAP, SCHEDULE_TYPES.SCHEDULED])),
    pickupTime: types.maybe(types.string),
    points: types.maybe(types.integer),
    pointsEarned: types.maybe(types.integer),
    restaurant: types.maybe(types.reference(Restaurant)),
    recipientsEmail: types.maybe(types.string),
  })
  .actions(self => ({
    update({
      deliveryTrackingUrl,
      estimatedDeliveryTime,
      orderId,
      orderReference,
      orderType,
      orderPickupType,
      pickupTime,
      restaurant,
      recipientsEmail,
    }) {
      self.deliveryTrackingUrl = deliveryTrackingUrl || undefined;
      self.estimatedDeliveryTime = estimatedDeliveryTime || undefined;
      self.orderId = orderId;
      self.orderReference = orderReference;
      self.orderType = orderType;
      self.orderPickupType = orderPickupType || undefined;
      self.pickupTime = pickupTime || undefined;
      self.restaurant = restaurant;
      self.recipientsEmail = recipientsEmail;
    },
    reset() {
      self.update({});
    },
  }))
  .views(self => ({
    get formattedPickupTime() {
      const { pickupTime } = self;
      return formatDateString(pickupTime);
    },
    get formattedDeliveryTime() {
      const { estimatedDeliveryTime } = self;
      return formatDateString(estimatedDeliveryTime);
    },
  }));

OrderConfirmationState.initialState = initialState;

export default OrderConfirmationState;
